const  en = {
    Category_Name:"Category Name",
    Filter:"Filter",
    Search_Key:"Search Key",
    Search:'Search',
    Product_List:"Product List",
    Add_New:"Add New",
    Product_Name:"Product Name",
    Sku:"Sku",
    Quantity:"Quantity",
    Price:"Price",
    Cross_Price:"Cross Price",
    Type:"Type",
    Status:"Status",
    Action:"Action",
    No_Data_Found:"No data found",
    Edit_Category:"Edit Category",
    Add_Category:"Add Category",
    Parent_Category:"Parent Category",
    Category_Description:"Category Description",
    Category_List:"Category List",
    Save:"Save",
    Reset:"Reset",
    Category:"Category",
    SubCategory:"SubCategory",
    From_When:"From When (Calendar)",
    From_Where:"From Where",
    Production_Method:"Production Method",
    Product_Ref_Type:"Product Ref Type",
    Short_Decription:"Short Decription",
    Product_Images:"Product Images",
    Description:"Description",
    First_Name:"First Name",
    Last_Name:"Last Name",
    Email:"Email",
    Password:"Password",
    Gender:"Gender",
    Mobile:"Mobile No",
    Add_Product:"Add Product",
    Edit_Product:"Edit Product",
    Cancel:"Cancel",
    Current_Password:"Current Password",
    New_Password:"New Password",
    Confirm_Password:"Confirm Password",
    Buyer_List:"Buyer List",
    Seller_List:"Seller List",
    Total_Seller:"Total Seller",
    Total_Buyer:"Total Buyer",
    Total_Category:"Total Category",
    Total_Product:"Total Product",
    Order_Status:"Order Status",
    Payment_Status:"Payment Status",
    Order_List:"Order List",
    Invoice_No:"Invoice No",
    Order_Date:"Order Date",
    Total_Qty:"Total Qty",
    Amount:"Amount",
    Service_Fee:"Service Fee",
    Total_Amount:"Total Amount",
    S_Fee_Status:"S Fee Status",
    Payment_Details:"Payment Details",
    Back:"Back",
    View_Order_Details:"View Order Details",
    Order:"Order",
    Total_Payment_Status:"Total Payment Status",
    Shipping_Address:"Shipping Address",
    nearby:"nearby",
    Download_Invoice:"Download Invoice",
    Download:"Download",
    Item_Details:"Item Details",
    Item_Quantity:"Item Quantity",
    Item_Price:"Item Price",
    Total_Price:"Total Price",
    Payment_Information:"Payment Information",
    Payment_Method:"Payment Method",
    Payment_Date:"Payment Date",
    Payment_Amount:"Payment Amount",
    Order_Summary:"Order Summary",
    Items:"Items", 
    Service_Tax:"Service Tax",
    Order_Total:"Order Total",
    Payment_Upload:"Payment Upload",
    Payment:"Payment",
    Verify:"Verify",
    From_Bank:"From Bank",
    Bank_Name:"Bank Name",
    Transaction_ID_optional:"Transaction ID (optional)",
    Upload_Screenshot:"Upload Screenshot",
    Submit:"Submit",
    Email_Address_Username:"Email Address / Username",
    Remember_me:"Remember me",
    Sign_in:"Sign in",
    Sign_in_with_Email_address:"Sign in with Email address",
    Branch_Name:"Branch Name",
    Account_Name_As_Per_Bank:"Account Name(As Per Bank)",
    Ifsc_Code:"Account Bank Code",
    Pin_Code:"Pin Code",
    Bank_QR_Code:"Bank QR Code",
    Updating:"Updating...",
    Update:"Update",
    Bag:"Bag",
    empty_bag:"empty bag",
    Hey_it_feels_so_light:"Hey, it feels so light",
    There_is_nothing_in_your_bag_Let_is_add_some_items:"There's nothing in your bag. Let's add some items",
    Nothing_Here:"Nothing Here!",
    Forgot_Password:"Forgot Password",
    Back_to_Home:"Back to Home",
    Send:"Send",
    Please_Wait:"Please Wait...",
    Code:"Code",
    Password_Mismatch:"Password Mismatch",
    Create_New_Account:"Create New Account",
    User_Email_Mobile:"User Email/Mobile",
    Login_to_your_account:"Login to your account",
    Thank_you_for_ordering_with_us:"Thank you for ordering with us :)",
    Please_check_your_mail_or_download_invoice_for_payment:"Please check your mail or download invoice for payment.",
    My_Proposals:"My Proposals",
    Recieved_Proposals:"Recieved Proposals",
    Nothing_to_Show:"Nothing to Show!",
    Send_Proposals:"Send Proposals",
    ID:"ID",
    Customer_Name:"Customer Name",
    Qty:"Qty",
    Created_Date:"Created Date",
    Details:"Details",
    About_Product:"About Product",
    Quantity_Kg:"Quantity (Kg)",
    Go_to_Bag:"Go to Bag",
    Buy_Now:"Buy Now",
    Average_Market_Price:"Average Market Price",
    Name:"Name",
    Seller:"Seller",
    Buyer:"Buyer",
    Country:"Country",
    City:"Soum",
    State:"Province",
    Current_Address_2:"Current Address 2",
    Current_Address_1:"Current Address 1",
    I_have_read_and_agree_to_nm:"I have read and agree to 9999.nm's",
    User_Agreement_and_Privacy_Policy:"User Agreement and Privacy Policy.",
    Sign_up:"Sign up",
    Create_Account:"Create Account",
    User_Agreement:"User Agreement",
    Close:"Close",
    Disclaimer_text:'Disclaimer: Termly Inc is not a lawyer or a law firm and does not engage in the practice of law or provide legal advice or legal representation. All information, software, services, and comments provided on the site are for informational and self-help purposes only and are not intended to be a substitute for professional legal advice. Use of this site is subject to our Terms of Use. Adding an “agree to terms and conditions” checkbox will likely require some coding on your website. You will also need to make sure you have accurate and up-to-date information in your terms and conditions. If you need assistance creating or updating your terms and conditions, Termly has a free terms and conditions generator. It allows you to choose the agreements for your business’s particular needs and decide exactly how you want them displayed. You can also use a template or choose to write your own terms and conditions.',
    Category_Average_Price: 'Category Average Price',
    Search_Your_Product:'Search Your Category',
    Explore:'Explore',
    Start_Shopping:'Start Shopping',
    Explore_More:'Explore More',
    BuySell_Text_1:'Buy & Sell the best Average Market Price from us.',
    BuySell_Text_2:'More than 100 types of products.',
    Add_New_Address:'Add New Address',
    Address:'Address',
    Do_you_Really_wants_Delete_address:'Do you Really wants to delete this address ?',
    Edit:'Edit',
    Remove:'Remove',
    Categories:'Categories',
    Mobile_No:'Mobile No.',
    Full_Name:'Full Name',
    Flat_House_no_Building:'Flat, House no., Building',
    Area_Colony_Street:'Area, Colony, Street',
    Near_By:'Near By',
    Town_City:'Town/City',
    Remove_from_Bag:'Remove from Bag',
    Qnty:'Qnty.',
    Proceed_to_Checkout:'Proceed to Checkout',
    Price_Details:'Price Details',
    Please_Add_bank_details_first:'Please Add bank details first!',
    item:'item',
    Proposal_sent:'Proposal sent!',
    Please_Login_to_continue:'Please Login to continue',
    Proposal_Accepted:'Proposal Accepted!',
    Proposal_is_Re_proposed:'Proposal is Re-proposed',
    Proposal_Rejected:'Proposal Rejected!',
    Above_proposal_is:'Above proposal is',
    Proposed_Price:'Proposed Price',
    Loading:'Loading ...',
    Limit_Exceeded:'Limit Exceeded ! ',
    KG:'KG',
    Kg:'Kg',
    View_Detail:'View Detail',
    Praposal_Details:'Praposal Details',
    Product_Details:'Product Details',
    Go_to_Praposal:'Go to Praposal',
    Add_Praposal:'Add Price Proposal',
    Sell_Now:'Sell Now',
    Login:'Login',
    Ragister:'Ragister',
    View_all:'View all',
    No_Message_Found:'No Message Found',
    Logout:'Logout',
    My_Orders:'My Orders',
    My_Products:'My Products',
    Profile:'Profile',
    Buy_Sell_Made_Easy_Powered_by_Vstacks:'Buy & Sell Made Easy Powered by  Vstacks',
    No_Item_to_show:'No Item to show',
    Place_Order:'Place Order',
    Total:'Total',
    Total_Products:'Total Products',
    Delivery_Date:'Delivery Date *',
    Discount:'Discount',
    Subtotal:'Subtotal',
    Confirm_Order:'Confirm Order',
    Internal_server_error:'Internal server error. Please try again!',
    Order_Successfull:'Order Successfull',
    Account_registered_successfully:'Account registered successfully.',
    Invalid_Link:'Invalid Link. Please Contact Admin. OR ',
    Account_Verified:'Account is Verified. Redirecting to ',
    Something_went_wrong:'Something went wrong. Please try again.',
    Default_Address_Updated:'Default Address Updated.',
    Address_Deleted:'Address Deleted.',
    Address_Updated:'Address Updated.',
    Address_Added:'Address Added.',
    Seller_Account_Missing:'Seller cant buy items. Please create a Buyer Account.',
    Product_Added_Bag:'Product Added to Bag',
    Some_Error_Occurred:'Some Error Occurred!!',
    Product_Removed_from_Bag:'Product Removed from Bag',
    Logged_out_successfully:'Logged out successfully!!',
    Logged_In_successfully:'Logged In successfully!!',
    Signed_Up_Successfully:'Signed Up Successfully. Please Check Your Mail for Activation!!',
    Order_Placed:'Order Placed',
    Order_Detail:'Order Detail',
    Change_Password:'Change Password',
    Preparing_For_Dispatch:'Preparing For Dispatch',
    Out_for_Delivery:'Out for Delivery',
    Delivered:'Delivered',
    Bank_Details:'Bank Details',
    My_Address:'My Address',
    Delivery_Status_changed_Successfully:'Delivery Status changed Successfully!',
    Please_Select_or_Add_ddress:'Please Select or Add an Address',
    Delivery_Date_missing:'Delivery Date is missing!' ,
    Already_have_an_account:'Already have an account', 
    You_not_register_for_category:'Your are not registered for this category.',
    Account_No:'Account No',
    Online:'Online',
    Upload_Sell:"Add Information To Sell",
    Upload_Buy:"Add Information To Buy",
    Delivered_By:'Delivered By',
    Change_Order_Status:'Change Order Status',
    Complete_Delivery:'Complete Delivery',
    Pay_Now:'Pay Now',
    Are_you_sure:'Are you sure?',
    Iban_No:'IBAN Number',
    select_category:'-- Select Category --',
    Set_price_Range:'Set price Range',
    Min_Price:'Min Price',
    Max_Price:'Max Price',
    Price_Range:'Price Range',
    Display_Only:'Display Only',
    Allowed_Price_Aange:'Allowed Price Aange',
    Price_Low:'Price must be greater than or equal to',
    Price_High:'Price must be less than or equal to',
    Invalid_price:'Invalid price range',
    View_All_Proposals:'View All Proposals',
    Proposals_Detail:'Proposals Detail',
    Plese_Login_as_buyer_to_add_proposal_on_this_product:'Plese Login as buyer to add proposal on this product',
    Plese_Login_as_seller_to_add_proposal_on_this_product:'Plese Login as seller to add proposal on this product',
    Category_Frontend_Settings:'Category Frontend Settings - ',
    Transportation_Categories:'Transportation Categories',
    Product_Categories:'Product Categories',
    Category_Type:'Category Type',
    select_userType:'-- Select User Type --',
    Transport_Type:'Transport Type',
    To_Where: 'To Where',
    Transport_Time: 'Transport Time',
    Countof_Transportation: 'Count of trruck/train/other',
    Quantity_Tonne:"Quantity (Tonne)",
    Tonne:"Tonne",
    Order_Now:"Order Now",
    Upload_Orderer:"Add Information to Order",
    Upload_Transport:"Add Information to Transport",
    Orderer:"Orderer",
    Transporter:"Transporter",
    Reservation_Msg:"Thank you for your reservation with 9999.mn. Kindly reach out to us using the contact details provided, and we will be happy to assist you promptly.",
    Contact_Information:"Company Contact Details",
    Reservation: "Reservation",
    Reservation_Summery:"Reservation Summery",
    Book_Reservation:"Book Reservation",
    Confirm_Reservation:"Confirm Reservation",
    Reservation_Successfull:"Reservation Successfull",
    Thank_Booking:"Thank you for your booking with us.",
    Add_Orderer:"Add Orderer",
    Add_Transporter:"Add Transporter",
    Edit_Transporter:"Edit Transporter",
    Edit_Orderer:"Edit Orderer",
    Transporter_List:"Transporter List",
    Orderer_List:"Orderer List",
    Add_Buyer:"Add Buyer",
    Add_Seller:"Add Seller",
    Edit_Seller:"Edit Seller",
    Edit_Buyer:"Edit Buyer",
    One_Time:  "One Time",
    Long_Term:  "Long Term",    
    Mining_Seller:"Seller (Mining)",
    Mining_Buyer:"Buyer (Mining)",
    Mining_Buy_Sell_Category_Alert:"Only Mining Buyer or Seller users are allowed, For Buy/Sell category.",
    My_Reservations: "My Reservations",
    Mining:'Mining',
}
export default en;
